import { render, staticRenderFns } from "./award-audit-detail.vue?vue&type=template&id=0e3b300a&"
import script from "./award-audit-detail.vue?vue&type=script&lang=js&"
export * from "./award-audit-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports